(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bb-article"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (scope) => {
      scope.querySelectorAll('[data-bb-editorial-article]').forEach((root) => {
        if (root.dataset.editorialReady) return;
        root.dataset.editorialReady = 'true';
        const body = root.querySelector('[data-article-body]');
        if (!body) return;
        const paragraphs = [...body.children].filter((element) => element.tagName === 'P');
        const lastAtAnchor = new Map();
        body.querySelectorAll(':scope > [data-editorial-block]').forEach((block) => {
          const position = Number(block.dataset.afterParagraph);
          const paragraph = Number.isInteger(position) && position > 0 ? paragraphs[position - 1] : null;
          if (!paragraph) return;
          (lastAtAnchor.get(paragraph) || paragraph).after(block);
          lastAtAnchor.set(paragraph, block);
        });
        body.querySelectorAll('table').forEach((table) => {
          table.tabIndex = 0;
          if (!table.hasAttribute('aria-label') && !table.querySelector('caption')) {
            table.setAttribute('aria-label', root.dataset.tableLabel);
          }
        });
        body.querySelectorAll('iframe').forEach((frame) => {
          if (!frame.title) frame.title = root.dataset.videoLabel;
        });
        const toc = root.querySelector('[data-article-toc]');
        const headings = [...body.querySelectorAll('h2')].filter((heading) => heading.textContent.trim());
        if (toc && Number(root.dataset.wordCount) >= 500 && headings.length >= 3) {
          const list = toc.querySelector('[data-article-toc-list]');
          headings.forEach((heading, index) => {
            if (!heading.id) {
              const base = 'article-' + root.dataset.sectionId + '-' + (index + 1);
              let id = base;
              let suffix = 1;
              while (document.getElementById(id)) id = base + '-' + suffix++;
              heading.id = id;
            }
            const item = document.createElement('li');
            const link = document.createElement('a');
            link.href = '#' + encodeURIComponent(heading.id);
            link.textContent = heading.textContent.trim();
            item.append(link);
            list.append(item);
          });
          toc.hidden = false;
        }
        const button = root.querySelector('[data-article-copy]');
        if (!button) return;
        button.hidden = false;
        button.addEventListener('click', async () => {
          const status = root.querySelector('[data-article-copy-status]');
          const fallback = root.querySelector('[data-article-copy-fallback]');
          button.disabled = true;
          try {
            if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
            await navigator.clipboard.writeText(button.dataset.url);
            fallback.hidden = true;
            status.textContent = button.dataset.success;
          } catch {
            fallback.hidden = false;
            status.textContent = button.dataset.error;
            const input = fallback.querySelector('input');
            input.focus();
            input.select();
          } finally {
            button.disabled = false;
          }
        });
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    } else {
      initialize(document);
    }
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-basic-info"] && !Shopify.designMode) return;
  try {
    
(function () {
  function sync(video) {
    var container = video.closest('.bb-basic-info__video');
    var button = container && container.querySelector('[data-bb-video-sound]');
    if (!button) return;
    var silent = video.muted || video.volume === 0;
    var label = silent ? 'Unmute video' : 'Mute video';
    button.dataset.muted = String(silent);
    button.setAttribute('aria-label', label);
    button.title = label;
    button.hidden = false;
  }
  function init() {
    document.querySelectorAll('.bb-basic-info__video video').forEach(sync);
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-bb-video-sound]');
    if (!button) return;
    var video = button.closest('.bb-basic-info__video').querySelector('video');
    if (!video) return;
    if (video.muted || video.volume === 0) {
      video.muted = false;
      if (video.volume === 0) video.volume = 1;
    } else {
      video.muted = true;
    }
    sync(video);
  });
  document.addEventListener('volumechange', function (event) {
    if (event.target.matches('.bb-basic-info__video video')) sync(event.target);
  }, true);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-chrome-scroll-test"]) return;
  try {
    
  (() => {
    const sandbox = document.querySelector('[data-bb-chrome-sandbox]');
    if (!sandbox) return;

    const currentCrumb = document.querySelector('.bb-crumb__current');
    if (currentCrumb) currentCrumb.setAttribute('aria-current', 'page');

    const root = document.documentElement;
    const header = document.querySelector('.bb-header');
    const navbar = document.querySelector('.bb-navbar');
    if (!header || !navbar) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const hideAfter = 140;
    const hideThreshold = 20;
    const revealThreshold = 8;
    const userIntentWindow = 1200;
    let lastY = window.scrollY || window.pageYOffset;
    let direction = 0;
    let distance = 0;
    let ticking = false;
    let lastIntentAt = -Infinity;
    let scrollbarPointerActive = false;

    const markIntent = () => { lastIntentAt = performance.now(); };
    const scrollKeys = ['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '];

    const reset = () => {
      root.classList.remove('bb-sandbox-chrome-hidden');
      lastY = window.scrollY || window.pageYOffset;
      direction = 0;
      distance = 0;
    };

    const update = () => {
      ticking = false;
      const y = window.scrollY || window.pageYOffset;
      const keepVisible =
        reducedMotion.matches ||
        y <= hideAfter ||
        root.classList.contains('bb-menu-open') ||
        root.classList.contains('bb-search-open') ||
        header.matches(':focus-within') ||
        navbar.matches(':focus-within');

      if (keepVisible) {
        reset();
        return;
      }

      const delta = y - lastY;
      lastY = y;
      if (delta === 0) return;
      if (performance.now() - lastIntentAt > userIntentWindow) {
        direction = 0;
        distance = 0;
        return;
      }

      const nextDirection = delta > 0 ? 1 : -1;
      if (nextDirection !== direction) {
        direction = nextDirection;
        distance = 0;
      }

      distance += Math.abs(delta);
      const threshold = direction > 0 ? hideThreshold : revealThreshold;
      if (distance < threshold) return;

      root.classList.toggle('bb-sandbox-chrome-hidden', direction > 0);
      distance = 0;
    };

    window.addEventListener('wheel', markIntent, { passive: true });
    window.addEventListener('touchmove', markIntent, { passive: true });
    window.addEventListener('pointerdown', (event) => {
      scrollbarPointerActive = event.pointerType === 'mouse' &&
        (event.clientX >= document.documentElement.clientWidth ||
         event.clientY >= document.documentElement.clientHeight);
      if (scrollbarPointerActive) markIntent();
    }, { passive: true });
    window.addEventListener('pointermove', (event) => {
      if (scrollbarPointerActive && event.buttons === 1) markIntent();
    }, { passive: true });
    window.addEventListener('pointerup', () => { scrollbarPointerActive = false; }, { passive: true });
    window.addEventListener('pointercancel', () => { scrollbarPointerActive = false; }, { passive: true });
    document.addEventListener('keydown', (event) => {
      if (event.defaultPrevented || event.altKey || event.ctrlKey || event.metaKey) return;
      if (!scrollKeys.includes(event.key)) return;
      const target = event.target;
      if (target && (target.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(target.tagName))) return;
      if (target && [' ', 'ArrowUp', 'ArrowDown'].includes(event.key) &&
          target.closest && target.closest('a, button, [role="button"], [role="tab"], [role="slider"], [role="combobox"], [role="menuitem"]')) return;
      markIntent();
    });
    window.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      },
      { passive: true }
    );

    header.addEventListener('pointerenter', reset);
    header.addEventListener('focusin', reset);
    navbar.addEventListener('pointerenter', reset);
    navbar.addEventListener('focusin', reset);
    reducedMotion.addEventListener('change', reset);
    reset();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
